module.exports = __webpack_public_path__ + "img/wz-7-2-1.8f2a4c34.jpg";